<template>
  <div class="n2-pagina" ref="raiz">
    <N2CabezaPagina :titulo="titulo" :subtitulo="P.Subtitulo?.Texto" :imagen="P.Imagen" :filtro="P.ImagenFiltro"
      :boton="P.ShowButton ? P.Button : null" />

    <section id="contact" class="n2-seccion n2-seccion--pagina">
      <div class="n2-contenedor n2-contacto-pagina">
        <!-- Datos de Contacto del panel; los iconos según "Mostrar iconos en las tarjetas" -->
        <div class="n2-datos-contacto n2-datos-contacto--pagina" :class="{ 'n2-datos-contacto--sin-iconos': P.ShowIcons === false }">
          <div v-if="C.Telefono || C.Movil || C.Fax" class="n2-dato n2-aparece">
            <v-icon>mdi-phone-outline</v-icon>
            <span>
              <strong>{{ $t('telefono') }}</strong><br>
              <a v-if="C.Telefono" :href="'tel:' + C.Telefono.replace(/\s/g, '')" class="n2-dato__grande">{{ C.Telefono.trim() }}</a>
              <template v-if="C.Movil"><br><a :href="'tel:' + C.Movil.replace(/\s/g, '')">{{ C.Movil.trim() }}</a></template>
              <template v-if="C.Fax"><br>{{ C.Fax }} (Fax)</template>
            </span>
          </div>
          <div v-if="C.Email || C.Email2" class="n2-dato n2-aparece">
            <v-icon>mdi-email-outline</v-icon>
            <span>
              <strong>{{ $t('email') }}</strong><br>
              <a v-if="C.Email" :href="'mailto:' + C.Email">{{ C.Email }}</a>
              <template v-if="C.Email2"><br><a :href="'mailto:' + C.Email2">{{ C.Email2 }}</a></template>
            </span>
          </div>
          <div v-if="C.Direccion" class="n2-dato n2-aparece">
            <v-icon>mdi-map-marker-outline</v-icon>
            <span>
              <strong>{{ $t('localizacion') }}</strong><br>
              <a :href="C.EnlaceMaps || undefined" target="_blank" rel="noopener">
                {{ C.Direccion }}<br>{{ [C.CP, C.Municipio].filter(Boolean).join(' ') }}<template v-if="C.Provincia && C.Provincia !== C.Municipio"> ({{ C.Provincia }})</template>
              </a>
            </span>
          </div>
          <div v-if="C.Horario" class="n2-dato n2-aparece">
            <v-icon>mdi-clock-outline</v-icon>
            <span>
              <strong>{{ NOTARIA.Theme.Footer?.TituloHorario?.Texto || tSolicitud('Horario') }}</strong>
              <span v-if="abierto !== null" class="n2-estado" :class="abierto ? 'n2-estado--abierto' : 'n2-estado--cerrado'">
                <span class="n2-estado__punto"></span>{{ tSolicitud(abierto ? 'Abierto ahora' : 'Cerrado ahora') }}
              </span>
              <br><span class="n2-pre">{{ C.Horario }}</span>
            </span>
          </div>
          <!-- En el panel, "Parking" guarda los accesos y "Accesos" el parking (se muestran como en la plantilla de siempre) -->
          <div v-if="C.Parking" class="n2-dato n2-aparece">
            <v-icon>mdi-bus</v-icon>
            <span><strong>{{ $t('accesos') }}</strong><br><span v-html="conSaltos(C.Parking)"></span></span>
          </div>
          <div v-if="C.Accesos" class="n2-dato n2-aparece">
            <v-icon>mdi-parking</v-icon>
            <span><strong>Parking</strong><br><span v-html="conSaltos(C.Accesos)"></span></span>
          </div>
        </div>

        <div v-if="urlMapa" class="n2-contacto-pagina__mapa n2-aparece">
          <iframe :src="urlMapa" :title="'Mapa de ' + NOTARIA.Nombre" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </section>

    <!-- Panel: Diseño páginas → Contacto → Formulario, con el diseño de formulario elegido -->
    <div v-if="P.Form?.Mostrar" class="n2-formulario n2-formulario--pagina">
      <ContactFormGuiado v-if="P.Form.Design === 2" :contactForm="style.ThemeFormContact" />
      <ContactFormPersonalizado v-else-if="P.Form.Design === 3" :contactForm="style.ThemeFormContact" />
      <ContactFormNotinTwo v-else-if="P.Form.Design === 1 || P.Form.Design == null" :contactForm="style.ThemeFormContact" />
      <ContactFormNotinOne v-else :contactForm="style.ThemeFormContact" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useStyles } from '../../store/styles'
import { useUtils } from '#imports'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, conSaltos, abiertoAhora, useAparicion } from '../../composables/useNotaria2'
import N2CabezaPagina from './N2CabezaPagina.vue'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const style = useStyles()
const { $t } = useUtils()
const raiz = ref(null)
useAparicion(raiz)

// Panel: Diseño páginas → Contacto (cabecera, iconos y formulario) y los datos de Contacto
const P = computed(() => NOTARIA.value?.Theme?.Contacto ?? {})
const C = computed(() => NOTARIA.value?.Contacto ?? {})
const titulo = computed(() => P.value.Titulo?.Texto || tituloSeccion(NOTARIA.value, 'Contacto', $t))

const abierto = ref(null)
onMounted(() => { abierto.value = abiertoAhora(C.value.HorarioEstructurado) })

// Mapa embebido sin clave de API (como en el pie), con las coordenadas del panel
const urlMapa = computed(() => {
  const c = C.value.Coordinates
  return c && Number(c.lat) && Number(c.lng) ? `https://maps.google.com/maps?q=${c.lat},${c.lng}&z=16&output=embed` : ''
})
</script>
